import { FC } from 'react';

import { Flex, StyleProps, Text } from '@bonusly/design-system';

import { ProfileLink } from '../../../../../modules/profile/components/profile-link';
import { ReactionAvatar } from './reaction-avatar';
import { ReactionData } from './types';

interface ReactionCardProps extends StyleProps {
	reaction: ReactionData;
}

export const ReactionCard: FC<ReactionCardProps> = ({ reaction, ...rest }) => {
	return (
		<Flex alignItems="center" {...rest}>
			<ReactionAvatar reaction={reaction} mr={4} />

			<Flex alignItems="flex-start" direction="column" flex={1} justifyContent="center" minWidth={0}>
				<ProfileLink userId={reaction.user.id} _hover={{ textDecoration: 'underline' }} color="text.default">
					<Text fontSize="md" fontWeight="medium" lineHeight="base">
						{reaction.user.display_name}
					</Text>
				</ProfileLink>
				<Text color="text.softer" fontSize="sm" fontWeight="normal" lineHeight="base">
					{reaction.user.username}
				</Text>
			</Flex>
		</Flex>
	);
};
